export const DTRSuccessModal: string = 'DTRSuccessModal';
